module.exports = __webpack_public_path__ + "img/quiz_flavor_outline.3efcb263.png";